"use strict";

exports.__esModule = true;
exports.PlantTwinFilter = PlantTwinFilter;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _FilterPopover = require("../FilterPopover");
var _FilterDeviceListController = require("../FilterDeviceListController");
var _FilterDeviceListContext = require("../FilterDeviceListContext");
var _SearchInput = require("../../Core/SearchInput");
var _PlantTwinContext = require("../../PlantTwin/PlantTwinContext/PlantTwinContext");
var _TreeViewElement = require("../../Widgets/TreeView/TreeViewElement");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _enrichHierarchyWithDeviceInfo = require("../../PlantTwin/PlantTwinTreeView/enrichHierarchyWithDeviceInfo");
var _ComponentSize = require("../../Core/ComponentSize");
var _Translator = require("../../Core/Translator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PopoverContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PlantTwinFilter__PopoverContentWrapper",
  componentId: "sc-1rfx2jf-0"
})(["height:", ";width:", ";.rst__rowContents,.rst__rowContentsDragDisabled{min-width:100px;}"], function (props) {
  return "calc(" + window.innerHeight + "px - " + props.theme.ToolbarHeight + " - " + props.theme.NavbarHeight + " - 16px)";
}, function () {
  return window.innerWidth / 3 + "px";
});
var inputSearchBarHeight = 40;
var Search = (0, _styledComponents["default"])(_SearchInput.SearchInput).withConfig({
  displayName: "PlantTwinFilter__Search",
  componentId: "sc-1rfx2jf-1"
})(["margin:8px;border-radius:20px;flex:1;"]);
var ButtonWrapper = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "PlantTwinFilter__ButtonWrapper",
  componentId: "sc-1rfx2jf-2"
})(["background:none !important;border:none !important;box-shadow:none !important;.", "{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal;max-width:250px;}"], _core.Classes.BUTTON_TEXT);
function PlantTwinFilter(_ref) {
  var property = _ref.property,
    _ref$showItemCount = _ref.showItemCount,
    showItemCount = _ref$showItemCount === void 0 ? false : _ref$showItemCount;
  var _useState = (0, _react.useState)([]),
    treeData = _useState[0],
    setTreeData = _useState[1];
  var _useState2 = (0, _react.useState)(""),
    searchString = _useState2[0],
    setSearchString = _useState2[1];
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var plantTwin = _react["default"].useContext(_PlantTwinContext.PlantTwinContext);
  var devices = _react["default"].useContext(_DeviceListContext.AllDeviceListContext) || [];
  var devicesMap = devices.reduce(function (acc, device) {
    acc[device.uuid] = {
      name: device.name,
      deviceType: device.deviceType,
      enabled: device.enabled
    };
    return acc;
  }, {});
  (0, _react.useEffect)(function () {
    (0, _enrichHierarchyWithDeviceInfo.enrichHierarchyWithDeviceInfo)({
      devicesMap: devicesMap,
      setTreeData: setTreeData,
      mode: "selection",
      data: plantTwin,
      fontSize: theme.fontSizeSmall,
      fontColor: theme.color,
      fontWeight: 400
    });
  }, [plantTwin, devices]);
  function renderSelectionText(selectedItems) {
    var placeholder = translate("DeviceHierarchySelector.placeholder.multiple", "Devices");
    var hasSelection = selectedItems.length > 0;
    var allDevicesSelected = selectedItems.length === devices.length + 1; // plant is also a device in selectedItems
    if (!hasSelection || allDevicesSelected) {
      return showItemCount ? /*#__PURE__*/_react["default"].createElement(_core.Text, {
        "data-testid": "TwinFilterSelectionText"
      }, translate("PlantTwinFilter.placeholder.all", "(All devices selected)")) : placeholder;
    }
    if (showItemCount) {
      return /*#__PURE__*/_react["default"].createElement(_core.Text, {
        "data-testid": "TwinFilterSelectionText"
      }, translate("PlantTwinFilter.countText", "{value} {value, plural, one {device} other {devices}} selected", {
        value: selectedItems.length
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(_core.Text, {
      ellipsize: true,
      "data-testid": "TwinFilterSelectionText"
    }, selectedItems.reduce(function (output, item, currentIndex, all) {
      var text = devicesMap[item] && devicesMap[item].name ? devicesMap[item].name : item;
      if (typeof text === "string") {
        output.push(text);
      } else {
        output.push(/*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: String(currentIndex)
        }, text));
      }
      var isLast = currentIndex === all.length - 1;
      if (!isLast) {
        output.push(", ");
      }
      return output;
    }, []));
  }
  return /*#__PURE__*/_react["default"].createElement(_FilterDeviceListController.FilterDeviceListController, {
    property: property
  }, function (filteredDeviceListProps) {
    return /*#__PURE__*/_react["default"].createElement(_FilterDeviceListContext.FilterDeviceListContext.Provider, {
      value: filteredDeviceListProps
    }, /*#__PURE__*/_react["default"].createElement(_FilterPopover.FilterPopover, {
      popoverContent: /*#__PURE__*/_react["default"].createElement(PopoverContentWrapper, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: "flex",
          flexShrink: 0,
          height: inputSearchBarHeight
        }
      }, /*#__PURE__*/_react["default"].createElement(Search, {
        placeholder: "Search"
        // eslint-disable-next-line jsx-a11y/no-autofocus
        ,
        autoFocus: true,
        value: searchString,
        onChange: function onChange(value) {
          return setSearchString(value);
        }
      })), /*#__PURE__*/_react["default"].createElement(_ComponentSize.ComponentSize, null, function (_ref2) {
        var width = _ref2.width,
          height = _ref2.height;
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: width,
            height: height - inputSearchBarHeight
          },
          "data-testid": "PlantTwinFilterDevicesList"
        }, /*#__PURE__*/_react["default"].createElement(_TreeViewElement.TreeViewElement, {
          setTreeData: setTreeData,
          treeData: treeData,
          mode: "selection",
          canDrag: function canDrag(_ref3) {
            var node = _ref3.node;
            return !!node.type;
          },
          canDrop: function canDrop(_ref4) {
            var nextParent = _ref4.nextParent;
            return !!nextParent;
          },
          searchQuery: searchString,
          searchFocusOffset: 0,
          rowHeight: 40
        }));
      })),
      popoverTarget: /*#__PURE__*/_react["default"].createElement(ButtonWrapper, {
        icon: _icons.IconNames.DIAGRAM_TREE,
        "data-testid": "PlantTwinFilterButton",
        text: renderSelectionText(filteredDeviceListProps.selectedDevices),
        rightIcon: _icons.IconNames.DOUBLE_CARET_VERTICAL
      })
    }));
  });
}